import { ChevronRight } from "lucide-react";

export function AccountRow({ icon: Icon, title, value, badge, testid }) {
  return (
    <div
      data-testid={testid}
      className="group flex items-center gap-4 w-full text-left p-4 sm:p-5 rounded-lg bg-white border border-border hover:border-gold/50 hover:shadow-sm transition-all cursor-pointer"
    >
      <span className="shrink-0 h-11 w-11 rounded-lg bg-gold/10 text-gold flex items-center justify-center">
        <Icon className="h-5 w-5" />
      </span>
      <div className="min-w-0 flex-1">
        <p className="font-display font-semibold text-navy">{title}</p>
        {value ? <p className="text-sm text-slate-500 truncate">{value}</p> : null}
      </div>
      {badge}
      <ChevronRight className="h-5 w-5 text-slate-300 group-hover:text-gold transition-colors" />
    </div>
  );
}
